import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { AuthQueryParamKey } from '../enums/auth-query-param-key';
import { AuthRoute } from '../enums/auth-route';
import { AuthRouterStateKey } from '../enums/auth-router-state-key';

export const registerEmailGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const router = inject(Router);

  const navigationState = router.currentNavigation()?.extras?.state;
  const companyId = navigationState?.[AuthRouterStateKey.COMPANY_ID];
  const email = navigationState?.[AuthRouterStateKey.EMAIL];
  const password = navigationState?.[AuthRouterStateKey.PASSWORD];

  const isToken = !!route.queryParamMap.get(AuthQueryParamKey.TOKEN);
  const areUserCredentials = companyId && email && password;
  if (isToken || areUserCredentials) return true;

  router.navigateByUrl(AuthRoute.LOGIN, {
    state: { [AuthRouterStateKey.IS_INVALID_ACTIVATE_TOKEN]: true },
  });
  return false;
};
